var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", [_c('input', {
    attrs: {
      "placeholder": _vm.field
    },
    domProps: {
      "value": _vm.getValue()
    },
    on: {
      "blur": _vm.setTouched,
      "input": function($event) {
        _vm.setValue(_vm.value)
      }
    }
  }), _vm._v(" "), (_vm.touched) ? _c('div', [_vm._v(_vm._s(_vm.error))]) : _vm._e()], {
    isReadonly: _vm.isReadonly,
    getTouched: _vm.getTouched,
    setTouched: _vm.setTouched,
    setValue: _vm.setValue,
    getError: _vm.getError,
    getValue: _vm.getValue
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6867466","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/form/components/Form/FormControl.vue
// module id = 675
// module chunks = 0